import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useFirestore } from 'reactfire';
import date from '@/utils/date';
import { useToast } from '@/hooks/useToast';
import useTeamsWorkbooks from '@/features/Workbooks/hooks/useTeamsWorkbooks';
import WorkbookIcon from '@/components/misc/WorkbookIcon';
import { Label, MegaSelect } from '@/components/FormElements';
import Button from '@/components/Button';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const WorkbooksMegaSelect = _ref => {
  let {
    teamId,
    workbookId,
    diabled,
    onSelect
  } = _ref;
  const firestore = useFirestore();
  const {
    addToast: sendNotification
  } = useToast();
  const {
    0: selectedWorkbook,
    1: setSelectedWorkbook
  } = useState(null);
  const {
    status,
    data,
    error
  } = useTeamsWorkbooks(firestore, teamId || 'na-team-id'); // show error notification if workbooks failed to load

  useEffect(() => {
    if (error) {
      sendNotification({
        description: 'There was an error loading your workbooks, please reload the page',
        type: 'error'
      });
    }
  }, [error, sendNotification]);

  const handleSelect = () => {
    if (selectedWorkbook) onSelect === null || onSelect === void 0 ? void 0 : onSelect(selectedWorkbook);
  };

  const isLoaded = status === 'success';
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.container),
    children: [/*#__PURE__*/_jsx(Label, {
      headingOnly: true,
      text: "Team Workbooks",
      children: /*#__PURE__*/_jsxs(MegaSelect.Root, {
        defaultValue: workbookId,
        onChange: value => {
          const workbook = data.find(wb => wb.id === value);

          if (workbook) {
            setSelectedWorkbook(workbook);
          }
        },
        children: [/*#__PURE__*/_jsx(MegaSelect.OpenButton, {
          className: styles.openButton,
          placeholder: isLoaded ? 'Select a workbook' : 'Loading...'
        }), /*#__PURE__*/_jsxs(MegaSelect.Content, {
          children: [/*#__PURE__*/_jsx(MegaSelect.Heading, {
            title: "Team Workbooks",
            subtitle: "Select a workbook to connect"
          }), /*#__PURE__*/_jsx(MegaSelect.Group, {
            children: data.map(workbook => {
              const description = `Created on ${date.toFullTextDate(workbook.createdAt)}`;
              return /*#__PURE__*/_jsx(MegaSelect.Option, {
                value: workbook.id || '',
                label: workbook.name || 'Unnamed',
                description: description,
                image: /*#__PURE__*/_jsx(WorkbookIcon, {
                  className: styles.icon,
                  originFileType: workbook.originFileType
                })
              }, workbook.id);
            })
          }), /*#__PURE__*/_jsx(MegaSelect.Footer, {})]
        })]
      })
    }), /*#__PURE__*/_jsx(Button, {
      type: "button",
      variant: "secondary",
      size: "large",
      className: styles.selectButton,
      disabled: diabled || !selectedWorkbook || !isLoaded,
      onClick: handleSelect,
      children: "Select Workbook"
    })]
  });
};

export default WorkbooksMegaSelect;